import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

// Componentes
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import FriendlyPhrase from '../../components/FriendlyPhrase/FriendlyPhrase';

// Contextos
import { useToast } from '../../contexts/ToastContext';
import { useLoader } from '../../contexts/LoaderContext';

// API
import { useInstitucionalService } from '../../services/institucionalService';

// Constantes
import { URLS } from '../../constants/urls';

// Estilos
import styles from './institucionalformpage.module.css';

function InstitucionalFormPage() {
    const { tipo } = useParams();
    const navigate = useNavigate();

    const { showToast } = useToast();
    const { showLoader, hideLoader } = useLoader();

    const { listarTodosInstitucionais, atualizarInstitucional } = useInstitucionalService();

    const [formData, setFormData] = useState({
        descricao: '',
        video: null
    });

    const [ids, setIds] = useState({
        descricao: null,
        video: null
    });

    const [previewVideo, setPreviewVideo] = useState(null);

    const TITULOS = {
        sante: 'Sobre a Santé',
        livro: 'Livro'
    };

    const titulo = TITULOS[tipo] || 'Institucional';

    useEffect(() => {
        if (!['sante', 'livro'].includes(tipo)) {
            showToast("Tipo inválido", 3000, 'error');
            navigate('/institucional');
            return;
        }

        const carregarDados = async () => {
            showLoader("Carregando dados");

            const res = await listarTodosInstitucionais();

            if (!res.success) {
                showToast("Erro ao buscar conteúdo", 3000, 'error');
                hideLoader();
                navigate('/institucional');
                return;
            }

            // Agora filtrando corretamente pelo campo "nome"
            const dados = res.data.filter(item => item.nome === tipo);
            console.log(`🔎 Dados encontrados para "${tipo}":`, dados);

            const descricaoObj = dados.find(i => i.tipo === 'descricao');
            const videoObj = dados.find(i => i.tipo === 'video');

            setFormData({
                descricao: descricaoObj?.valor || '',
                video: null
            });

            setIds({
                descricao: descricaoObj?.id || null,
                video: videoObj?.id || null
            });

            if (videoObj?.valor) {
                const url = `${URLS.IMG_PATH}${videoObj.valor}`;
                console.log("📺 URL do vídeo montada:", url);
                setPreviewVideo(url);
            } else {
                console.log("⚠️ Nenhum vídeo anterior encontrado");
            }

            hideLoader();
        };

        carregarDados();
    }, [tipo]);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setFormData(prev => ({ ...prev, video: file }));

        const url = URL.createObjectURL(file);
        setPreviewVideo(null);
        setTimeout(() => setPreviewVideo(url), 0);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        showLoader("Salvando");

        try {
            // Atualiza descrição
            if (ids.descricao) {
                const formDesc = new FormData();
                formDesc.append('id', ids.descricao);
                formDesc.append('valor', formData.descricao);
                const resDesc = await atualizarInstitucional(formDesc);
                console.log("📝 Atualização da descrição:", resDesc);
            }

            // Atualiza vídeo
            if (ids.video && formData.video) {
                const formVid = new FormData();
                formVid.append('id', ids.video);
                formVid.append('video', formData.video);
                const resVid = await atualizarInstitucional(formVid);
                console.log("📽️ Atualização do vídeo:", resVid);
            }

            showToast("Conteúdo atualizado!", 3000, 'success');
            navigate('/institucional');
        } catch (err) {
            console.error("❌ Erro ao enviar dados:", err);
            showToast("Erro ao enviar dados", 4000, 'error');
        } finally {
            hideLoader();
        }
    };

    return (
        <div className={styles.InstitucionalFormPage}>
            <div className={styles.containerTop}>
                <Breadcrumbs currentLabel={titulo} />

                <h1 className={styles.title}>Editar {titulo}</h1>
                <FriendlyPhrase page={'atualizarInstitucional'} />
            </div>

            <form onSubmit={handleSubmit} className={styles.formulario}>
                <div className={styles.generalArea}>
                    <h2 className={styles.sectionTitle}>Conteúdo</h2>

                    <label>
                        Descrição:
                        <textarea
                            value={formData.descricao}
                            onChange={(e) =>
                                setFormData({ ...formData, descricao: e.target.value })
                            }
                            required
                        />
                    </label>

                    <label>
                        Vídeo:
                        <div className={styles.fileInputWrapper}>
                            <input
                                type="file"
                                accept="video/*"
                                className={styles.fileInput}
                                onChange={handleFileChange}
                            />
                            <span className={styles.fileLabel}>Selecionar Vídeo</span>
                        </div>
                    </label>

                    {previewVideo && (
                        <video controls className={styles.videoPreview}>
                            <source src={previewVideo} type="video/mp4" />
                            Seu navegador não suporta vídeo.
                        </video>
                    )}
                </div>

                <div className={styles.submitArea}>
                    <button type="submit" className={styles.submitButton}>
                        Salvar Conteúdo
                    </button>
                </div>
            </form>
        </div>
    );
}

export default InstitucionalFormPage;